let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lWJHA")).then(() => parcelRequire('chRFA'));